import { Ledger } from "@common/contracts/ledger.contract";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { Entity } from "@common/types/entity";
import { exportTaxPackage } from "@api/accountingReports.api";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";

export function selectTaxPackageLedgerId(
    ledgers: readonly Ledger[] | undefined,
): string | undefined {
    if (!ledgers || ledgers.length === 0) {
        return undefined;
    }

    return (
        ledgers.find((ledger) => ledger.basis === AccountingLedgerBasis.cash)
            ?.id ?? ledgers[0].id
    );
}

export async function saveTaxPackage({
    entity,
    ledgerId,
}: {
    entity: Entity;
    ledgerId: string;
}): Promise<void> {
    const response = await exportTaxPackage(entity.id, ledgerId);
    if (!response) {
        return;
    }

    saveBlobResponse(
        response,
        `${entity.name} - 2025 Year-End Tax Package.xlsx`,
    );
}

export function useTaxPackageDownload(entity?: Entity, ledgerId?: string) {
    return useFileDownload(async () => {
        if (!entity || !ledgerId) {
            return;
        }

        await saveTaxPackage({ entity, ledgerId });
    });
}
